import React from 'react';
import classnames from 'classnames';
import { isBrowser } from 'react-device-detect';

import HotelSelector from 'components/molecules/HotelSelector';
import LanguageSelector from 'components/molecules/LanguageSelector';

import styles from './index.css';

const Navigator = ({ className, type, language, hotel, onLangSelect, onHotelSelect }) => (
	<nav
		className={classnames(styles.navigator, className, {
			[styles.reverse]: type === 'hotel',
			[styles.home]: type === 'home',
			[styles.hotel]: type === 'hotel',
		})}
	>
		<span className={styles.languageSelector}>
			{/* eslint-disable indent */}
			<LanguageSelector
				selectedLanguage={language}
				onSelect={onLangSelect}
				selectBoxConfig={
					type === 'home'
						? {
								class: classnames(styles.homeSelectBox, styles.language, {
									[styles.isBrowser]: isBrowser,
								}),
								activeClass: styles.homeSelectBoxActive,
								triangleColor: 'white',
								triangleBorderWidth: 2,
						  }
						: {
								class: styles.hotelSelectBox,
								activeClass: styles.hotelSelectBoxActive,
								triangle: true,
								triangleColor: 'white',
								triangleBorderWidth: 2,
						  }
				}
				optionConfig={{
					border: false,
					optionClass: classnames(styles.options, styles[language], {
						[styles.hotelOptions]: type === 'hotel',
					}),
				}}
			/>
			{/* eslint-enable indent */}
		</span>
		<span className={styles.hotelSelector}>
			{/* eslint-disable indent */}
			<HotelSelector
				isHeaderSelect // isHeaderSelect is used to determine if the hotel selector is a header select issue-#175
				withHomeSelection={type === 'hotel'}
				selectedHotel={hotel}
				onSelect={onHotelSelect}
				selectBoxConfig={{
					class: classnames(styles.hotel, styles[language], {
						[styles.homeSelectBox]: type === 'home',
						[styles.hotelSelectBox]: type === 'hotel',
					}),
					activeClass: classnames({
						[styles.homeSelectBoxActive]: type === 'home',
						[styles.hotelSelectBoxActive]: type === 'hotel',
					}),
					triangleDown: type === 'home',
					triangleColor: 'white',
					triangleBorderWidth: 2,
				}}
				optionConfig={{
					border: false,
					optionClass: classnames(styles.options, styles[language], {
						[styles.hotelOptions]: type === 'hotel',
					}),
				}}
			/>
			{/* eslint-enable indent */}
		</span>
	</nav>
);

export default Navigator;



// WEBPACK FOOTER //
// ./src/components/molecules/Navigation/component.js